import { faTruck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Card } from "react-bootstrap";

import {
  DateRangeFilter,
  dateBetweenFilterFn,
} from "../../../../components/tables/DateRangeFilter";
import ServerSideTable from "../../../../components/tables/ServerSideTable";

import { ShipmentsContext } from "./ShipmentAccount";

const Shipments = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [paginationOptions, setPaginationOptions] = useState({
    pageIndex: 0,
    pageSize: 10,
    pageCount: 0,
  });
  const [totalCount, setTotalCount] = useState(0);

  const {
    selectedAccount,
    shipments,
    setShipments,
    getShipments,
    setSelectedShipmentItems,
    getShipmentCartons,
    getShipmentItems,
  } = useContext(ShipmentsContext);

  useEffect(() => {
    initialize();
  }, []);

  const handleRowClick = useCallback((row) => {
    getShipmentItems(row.original);
    getShipmentCartons(row.original);

    // Reset the states
    setSelectedShipmentItems();
  }, []);

  const initialize = async () => {
    setIsLoading(true);

    const result = await getShipments({
      sellingPartnerId: selectedAccount.sellingPartnerId,
      pageIndex: 0,
      pageSize: 10,
    });

    setShipments(result.shipments);
    setPaginationOptions({
      pageIndex: result.pageIndex,
      pageSize: result.pageSize,
      pageCount: result.pageCount,
    });
    setTotalCount(result.totalCount);

    setIsLoading(false);
  };

  const fetchData = useCallback(async (params) => {
    setIsLoading(true);
    const { globalFilter, filters, pageIndex, pageSize, sortBy } = params;

    // Account for createdAt being an array of [min, max] date objects.
    const queryParams = filters.reduce((acc, curr) => {
      if (!acc[curr.id] && curr.id !== "createdAt") {
        acc[curr.id] = curr.value;
      } else if (curr.id === "createdAt") {
        acc["createdAtStart"] = curr.value[0];
        acc["createdAtEnd"] = curr.value[1];
      }

      return acc;
    }, {});

    const result = await getShipments({
      sellingPartnerId: selectedAccount.sellingPartnerId,
      globalSearch: globalFilter,
      ...queryParams,
      pageIndex,
      pageSize,
      sortBy,
    });

    setShipments(result.shipments);
    setPaginationOptions({
      pageIndex: result.pageIndex,
      pageSize: result.pageSize,
      pageCount: result.pageCount,
    });
    setTotalCount(result.totalCount);

    setIsLoading(false);
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Shipment ID",
        accessor: "amazonShipmentId",
      },
      {
        Header: "Destination ID",
        accessor: "shipTo",
      },
      {
        Header: "City",
        accessor: "shipToCity",
      },
      {
        Header: "State",
        accessor: "shipToState",
      },
      {
        Header: "Total Skus",
        accessor: "units",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        id: "createdAt",

        Cell: ({ value }) => {
          return new Date(value).toDateString();
        },
        Filter: DateRangeFilter,
        filter: dateBetweenFilterFn,
      },
      // {
      //   Header: "Rack IDs",
      //   accessor: "shipmentRackIds",
      // },
    ],
    []
  );

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between">
        <div className="d-flex justify-content-start">
          <FontAwesomeIcon icon={faTruck} size="3x" className="me-3" />
          <div>
            <Card.Title>Shipments</Card.Title>
            <Card.Subtitle>
              All the shipments for account{" "}
              <strong>{selectedAccount.listingAccount}</strong>.
            </Card.Subtitle>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <h1>{selectedAccount.listingAccount}</h1>
        </div>
      </Card.Header>
      <Card.Body>
        {shipments && (
          <ServerSideTable
            columns={columns}
            data={shipments}
            fetchData={fetchData}
            isLoading={isLoading}
            paginationOptions={paginationOptions}
            totalCount={totalCount}
            handleRowClick={handleRowClick}
            downloadFile={`Shipments_${selectedAccount.listingAccount}`}
            layoutFixed={true}
          />
        )}
      </Card.Body>
    </Card>
  );
};

export default Shipments;
